import { render } from "./HelpVideos.vue?vue&type=template&id=78f1c1fe"
import script from "./HelpVideos.vue?vue&type=script&lang=js"
export * from "./HelpVideos.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PageTitle from "@/components/PageTitle.vue";
import HelpVideoList from "@/components/HelpVideoList.vue";
script.components = Object.assign({}, { Breadcrumbs, PageTitle, HelpVideoList }, script.components);